(function () {
  "use strict";

  var SECTION_SELECTOR = "[data-wb-mincrd]";

  function initCarousel(section) {
    if (!section || section.__wbMincrdInit) return;

    var track = section.querySelector(".wb-mincrd__track");
    var btnPrev = section.querySelector(".wb-mincrd__arrow--prev");
    var btnNext = section.querySelector(".wb-mincrd__arrow--next");
    var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var resizeTimer = null;
    var rafId = null;

    if (!track) return;

    section.__wbMincrdInit = true;

    function updateButtons() {
      if (!btnPrev || !btnNext) return;

      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;

      btnPrev.disabled = scrollLeft <= 5;
      btnNext.disabled = scrollLeft >= maxScroll - 5;
    }

    function getStep() {
      var firstItem = track.querySelector(".wb-mincrd__item");
      if (!firstItem) return track.clientWidth * 0.8;

      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return firstItem.clientWidth + gap;
    }

    function onScroll() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateButtons);
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateButtons, 150);
    }

    track.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });

    if (btnPrev) {
      btnPrev.addEventListener("click", function (event) {
        event.preventDefault();
        track.scrollBy({ left: -getStep(), behavior: prefersReduced ? "auto" : "smooth" });
      });
    }

    if (btnNext) {
      btnNext.addEventListener("click", function (event) {
        event.preventDefault();
        track.scrollBy({ left: getStep(), behavior: prefersReduced ? "auto" : "smooth" });
      });
    }

    updateButtons();

    section.__wbMincrdCleanup = function () {
      track.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      clearTimeout(resizeTimer);
      if (rafId) cancelAnimationFrame(rafId);
      section.__wbMincrdInit = false;
    };
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section) initCarousel(section);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section && section.__wbMincrdCleanup) section.__wbMincrdCleanup();
  });
})();